import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../constants/api";
import { baseUrl } from "../constants/url";
import Select from "react-select";
import AsyncSelect from 'react-select/async';

export const customStyle = {
  option: (base: any, { isSelected }: any) => {
    let newbase = {
      ...base,
      backgroundColor: isSelected ? "#5757fe" : "#fff",
      color: isSelected ? "#fff" : "#000",
      "&:hover": {
        color: isSelected ? "#fff" : "#000",
        backgroundColor: isSelected ? "#5757fe" : "#5757fe22",
      },
      "&:focus-visible": {
        color: "#fff",
      },
      ":active": {
        color: "#ffffff",
        backgroundColor: "#5757fe",
      },
      "&:active": {
        color: "#ffffff",
        backgroundColor: "#5757fe",
      },
      "&:target": {
        color: "#fff",
      },
    };
    return newbase;
  },
  valueContainer: (style: any) => ({
    ...style,
    padding: "5px",
  }),
  container: (style: any) => ({
    ...style,
    width: "100%",
  }),
  multiValue: (style: any) => ({
    ...style,
    borderRadius: "20px",
    color: "#ffffff",
    backgroundColor: "#5757fe",
  }),
  multiValueLabel: (style: any) => ({
    ...style,
    color: "#fff",
    paddingTop: "9px",
    paddingBottom: "9px",
    paddingLeft: "15px",
    paddingRight: "9px",
    fontSize: "70%",
    transition: "all 0.3s ease",
  }),
  multiValueRemove: (style: any) => ({
    ...style,
    color: "white",
    backgroundColor: "#5757fe",
    borderRadius: "20px",
    height: "20px",
    marginTop: "8px",
    marginRight: "10px",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "#fff",
      color: "#5757fe",
    },
  }),
  indicatorSeparator: (style: any) => ({
    ...style,
    display: "none",
  }),
};

// const optionList: { value: string; label: string }[] = [
//   { value: "red", label: "Red" },
//   { value: "green", label: "Green" },
//   { value: "yellow", label: "Yellow" },
//   { value: "blue", label: "Blue" },
//   { value: "white", label: "White" },
// ];

const NotificationScreen = () => {
  const [appUser, setAppUser] = useState("");
  const [fcmTokenData, setFcmTokenData] = useState<any>([]);
  const [memberInfo, setMemberInfo] = useState<any>({});
  const [memberLoading, setMemberLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState<any>([]);
  const [inputValue, setValue] = useState<any>('');
  const [formData, setFormData] = useState({
    userId: "",
    title: "",
    body: "",
  });


  const getFcmTokenData = async () => {
    const res = await api(true, `/admin/getFcmRegistrationToken`, "get");
    setFcmTokenData(res.data);
  };

  const getMemberInfo = async () => {
    try {
      setMemberLoading(true);
      const res = await api(true, `/admin/get-all-members`, "get");
      const data: any = {};
      for (let member of res?.data?.data?.result || []) {
        data[member.idNumber] = member;

      }
      // console.log(data);
      setMemberInfo(data);
    } catch (error) {
      console.log(error, " <== Error while fetching member info");
    } finally {
      setMemberLoading(false);
    }
  };

  useEffect(() => {
    // if (localStorage.getItem('lastAuthTimeMillis') &&
    // // @ts-ignore
    // parseInt(localStorage.getItem('lastAuthTimeMillis')) > (new Date().getTime()) - 30*60*1000) {
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberCode'] = localStorage.getItem('MemberCode');
    //    // @ts-ignore
    //   axios.defaults.headers.common['MemberId'] = localStorage.getItem('MemberId');
    //    // @ts-ignore
    //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('Authorization');
    // } else {
    //   window.location.href = '/';
    // }
    getFcmTokenData();
    getMemberInfo();
  }, [appUser]);

  const handleSubmit = (event: any) => {
    event.preventDefault();

    if(!formData.title){return alert("Please add title")}
    if(!formData.body){return alert("Please add body")}

    api(true, "/admin/fcmRegistrationToken", "post", {
      type: appUser,
      userId: appUser == 'All' ? null : selectedOption.map((item:any)=>item.value),
      title:  formData.title,
      content: formData.body,
    })
      .then((res) => {
        alert("notification sent");
        setFormData({
          userId: "",
          title: "",
          body: "",
        });
      })
      .catch((error) => {
        console.log(error.response.data.message);
        if (error.response.data.message === "Data too long for column 'content' at row 1") {
          alert("Body is too long");
        } else {
          alert(error.message);
        }
      });
  };

  function handleSelect(data: any) {
    setSelectedOption(data);
  }

  // const handleInputChange = (value:any) => {
  //   setSelectedOption(value);
  // };
  
  const loadOptions = Object.values(memberInfo).map((item: any) => { 
    return ({ label: item.memberName || item.idNumber, value: item.idNumber}
      // <option
      //   value={item.userId}
      //   selected={formData.userId === item.userId}
      // >
      //   {memberLoading
      //     ? "Loading.."
      //     : memberInfo[item.userId]?.memberName || item.userId}
      // </option>
       ) })

    // const loadOptions=[
    //   {label:"Aakash Dave",value:1},
    //   {label:"John Abraham",value:2},
    //   {label:"Salman khan",value:3},
    // ]

  return (
    <div className="basePriceContainer">
      <h2 className="h2header basePrice">PUSH NOTIFICATION</h2>
      <div
        className="notification-radio-group"
        style={{
          display: "flex",
          flexDirection: "column", // default to column for mobile
          justifyContent: "center",
          alignItems: "center",
          padding: "20px 20px 0 20px",
        }}
      >
        <label style={{ marginBottom: 8 }}>Send Notification To:</label>
        <div className="notification-radio-options" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
        }}>
          <input
            type="radio"
            value="All"
            name="member"
            onChange={(event) => setAppUser(event.target.value)}
          />
          <h2 style={{ margin: 0, fontSize: 18, textAlign: 'center' }}>All Member</h2>
          <input
            type="radio"
            value="multi"
            name="member"
            onChange={(event) => setAppUser(event.target.value)}
          />
          <h2 style={{ margin: 0, fontSize: 18, textAlign: 'center' }}>Multiple Member</h2>
        </div>
      </div>
      <form
        className="form-basePrice"
        style={{ display: "block" }}
        onSubmit={handleSubmit}
      >
        {appUser === "multi" && (
          <div
            className="member-select-row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: '100%',
              boxSizing: 'border-box',
              gap: '10px',
            }}
          >
            <label style={{minWidth: 300, textAlign: 'center', height: '100%'}}>Choose Member:</label>
            <div style={{flex: 1, maxWidth: '1000px', width: '100%'}}>
              <Select
                options={loadOptions}
                placeholder="Select Member"
                value={selectedOption}
                onChange={handleSelect}
                isSearchable={true}
                isMulti
                styles={{
                  ...customStyle,
                  menu: (base: any) => ({
                    ...base,
                    zIndex: 9999
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    zIndex: 9999
                  })
                }}
              /> 
            </div>
          </div>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <label>Title:</label>
            <input
              type="text"
              value={formData.title}
              style={{
                fontSize: 20,
                width: 300,
              }}
              onChange={(event) =>
                setFormData({ ...formData, title: event.target.value })
              }
            ></input>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <label>Body:</label>
            <textarea
              value={formData.body}
              style={{ width: 300, height: 150, fontSize: 20 }}
              onChange={(event) =>
                setFormData({ ...formData, body: event.target.value })
              }
            ></textarea>
          </div>
          <button className="submitbtn" type="submit">
            SEND
          </button>
        </div>
      </form>
    </div>
  );
};

export default NotificationScreen;
